export default __webpack_public_path__ + "static/media/icon-skip.26d99a75.svg";